const seriesReducer = (curr, next) => {
  const p = curr.length ? curr[curr.length - 1] : Promise.resolve();
  curr.push(p.then(next));
  return curr;
};
const series = (a) => Promise.all(a.reduce(seriesReducer, []));

const pipe = (...functions) => (param) =>
  functions.reduce((prev, curr) => curr(prev), param);

const onlyUsefulBits = ({ title, content, hidden }) => ({
  title,
  content,
  hidden,
});

const strinfigyContent = (obj) => ({
  ...obj,
  content: JSON.stringify(obj.content),
});

const setWriter = (userId) => (section) => ({ ...section, writer: userId });

const prepareSection = (userId) =>
  pipe(onlyUsefulBits, strinfigyContent, setWriter(userId));

/**
 * @param {function} save
 * @param {string} userId
 * @param {any} material
 * @param {any[]} material.material
 * @return {Promise.<any>}
 */
const v1Importer = (save, userId, material) => {
  const sections = material.map(prepareSection(userId));
  return series(sections.map(save));
};

export default v1Importer;
